var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-b2b"},[_c('base-link',{staticClass:"social-link",attrs:{"to":'buss-to-buss',"title":"Zapraszamy do współpracy"}},[_vm._v(" "+_vm._s(_vm.value.fixedBtn)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }